/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type COMMENT_FLAG_REPORTED_REASON = "COMMENT_REPORTED_OFFENSIVE" | "COMMENT_REPORTED_OTHER" | "COMMENT_REPORTED_SPAM" | "%future added value";
export type CreateCommentFlagInput = {
    readonly commentID: string;
    readonly commentRevisionID: string;
    readonly reason: COMMENT_FLAG_REPORTED_REASON;
    readonly additionalDetails?: string | null;
    readonly clientMutationId: string;
};
export type CreateCommentFlagMutationVariables = {
    readonly input: CreateCommentFlagInput;
};
export type CreateCommentFlagMutationResponse = {
    readonly createCommentFlag: {
        readonly comment: {
            readonly id: string;
            readonly viewerActionPresence: {
                readonly flag: boolean;
            } | null;
        } | null;
        readonly clientMutationId: string;
    };
};
export type CreateCommentFlagMutation = {
    readonly response: CreateCommentFlagMutationResponse;
    readonly variables: CreateCommentFlagMutationVariables;
};



/*
mutation CreateCommentFlagMutation(
  $input: CreateCommentFlagInput!
) {
  createCommentFlag(input: $input) {
    comment {
      id
      viewerActionPresence {
        flag
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CreateCommentFlagInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "createCommentFlag",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateCommentFlagPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "comment",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Comment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewerActionPresence",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ActionPresence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "flag",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CreateCommentFlagMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "CreateCommentFlagMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "CreateCommentFlagMutation",
            "id": "7ae5e71791620cfcba8a23ad0596dadd",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '9068361f37bd69f339c6d2302ae3b9f6';
export default node;
